import DefaultsSettingsTag from './DefaultsSettingsTag.component';

export default DefaultsSettingsTag;
